module.exports = __webpack_public_path__ + "static/media/Cyndaquil_gaussian2.2a99ea94.png";